//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const HidePaymentsReceiptOnBuiltinPdfs: FeatureFlag = {"Id":"HidePaymentsReceiptOnBuiltinPdfs","Label":"Hide payments receipt on builtin pdfs","Impact":"On the builtin PDF used when a form has no PDF activity, hide the payment information section","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
